import React from "react";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import Hero from "../components/home/Hero";
import EventsBanner from "../components/home/EventsBanner";
import PatientValueProps from "../components/home/PatientValueProps";
import TherapistValueProps from "../components/home/TherapistValueProps";
import TherapistDirectory from "../components/home/TherapistDirectory";
import CallToAction from "../components/home/CallToAction";
import Pricing from "../components/home/Pricing";

const Index = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        <Hero />
        <TherapistDirectory />
        <EventsBanner />
        <PatientValueProps />
        <TherapistValueProps />
        <Pricing />
        <CallToAction />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
